import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import TournamentNavigator from "../../../navigation/TournamentNavigator";
import styles from "./tournamentSettings.module.css";

const TournamentSettings = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {rolePermissions.includes("view-tournaments") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/tournaments/show-all-tournaments">
                عرض جميع البطولات
              </PageLink>
            </div>
          )}
          {rolePermissions.includes("create-tournaments") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/tournaments/add-new-tournament">
                اضافة بطولة جديده
              </PageLink>
            </div>
          )}
          {rolePermissions.includes("view-tournaments") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/tournaments/search-one-tournament">
                البحث عن بطولة
              </PageLink>
            </div>
          )}
          {rolePermissions.includes("control-tournament-access") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/tournaments/control-tournaments-access">
                التحكم في الوصول الى البطولات
              </PageLink>
            </div>
          )}
          {rolePermissions.includes("control-images") && (
            <div className={styles.linkWrapper}>
              <PageLink destination="/dashboard/tournaments/edit-tournaments-images">
                التحكم في صور البطولات
              </PageLink>
            </div>
          )}
        </div>
      </HorizantalBar>
      <TournamentNavigator />
    </div>
  );
};

export default TournamentSettings;
